import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceGroupsDto } from '@pragma/dto';
import { Observable, catchError, of } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
    providedIn: 'root'
})
export class DeviceGroupsService {
    constructor(private readonly _httpClient: HttpClient) {}

    public getById(id: number): Observable<DeviceGroupsDto> {
        return this._httpClient.get<DeviceGroupsDto>(`/device-group?id=${id}`, httpOptions);
    }

    public getDeviceGroups(locationId: number) {
        return this._httpClient.get<Array<DeviceGroupsDto>>('/device-group/device-groups?locationId=' + locationId);
    }

    public getDeviceGroupsByType(locationId: number, type: string) {
        return this._httpClient.get<Array<DeviceGroupsDto>>(
            '/device-group/device-groups-by-type?locationId=' + locationId + '&deviceType=' + type
        );
    }

    public Delete(id: number): Observable<any> {
        return this._httpClient.delete<any>(`/device-group?id=${id}`, httpOptions);
    }

    public Update(id: number, data: any): Observable<any> {
        return this._httpClient.put(`/device-group?id=${id}`, data, httpOptions);
    }

    public Post(data: any): Observable<any> {
        const response = this._httpClient
            .post('/device-group', data, httpOptions)
            .pipe(catchError(this.handleError('')));
        return response;
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
